// AUTO-GENERATED by scripts/inject-build-info.js — do not edit manually
export const BUILD_INFO = {
  commitHash: 'dev',
  buildTime: '2026-11-05T01:11:38.284Z',
} as const;
